<template>
  <NuxtImg
    v-if="show"
    class="garage-wgz"
    src="/_nuxt/wgz.svg"
    width="65"
    height="90"
    alt="Program Kierowcy Polecają"
  />
</template>

<script
  setup
  lang="ts"
>
import type { GarageTagJsonldGarageTagReadTagRead } from '~/api/docs/api';


interface IProps {
  garageTags?: GarageTagJsonldGarageTagReadTagRead[];
}

// computed
const show: ComputedRef<boolean> = computed(() => {
  return !!props.garageTags?.find(tag => tag.tag?.name === 'WGZ');
});

const props = defineProps<IProps>();

</script>

<style
  lang="scss"
  scoped
>
@import url('assets/styles/components/garage-wgz.scss');
</style>